import { z } from 'src/lib'
import { OperacionWRMFields } from '../types/fields'
import { BaseResponse } from 'src/types'
import { getEndpoint } from './httpWRM'
import { HttpAxiosRequest } from 'src/http/httpAxiosBase'
import { InstrumentoPutFields } from './instrumento-fields'

const schema = z.object({
    [OperacionWRMFields.CodPais]: z.number(),
    [OperacionWRMFields.CodSectorComercial]: z.number(),
    [OperacionWRMFields.Observaciones]: z.string().optional(),
    [OperacionWRMFields.FechaEmision]: z.date(),
    [OperacionWRMFields.FechaVencimiento]: z.date(),
    [OperacionWRMFields.BitEnvio]: z.boolean(),
    [OperacionWRMFields.Detalles]: z.array(
        z.object({
            [InstrumentoPutFields.CodOperacionLimiteTipo]: z.number(),
            [InstrumentoPutFields.Excepcion]: z.string(),
            [InstrumentoPutFields.ValorNominal]: z.number(),
            [InstrumentoPutFields.CashValueUSD]: z.number(),
            [InstrumentoPutFields.Instrumento]: z.string()
        })
    )
})

export type OperacionWRM_Create = z.infer<typeof schema>

export const post = (operacion: OperacionWRM_Create): Promise<BaseResponse> => {
    const endpoint = getEndpoint()

    const parsed = schema.safeParse(operacion)

    if (!parsed.success) {
        console.error('Error de validación:', parsed.error.issues)

        return Promise.reject(new Error('Error de validación.'))
    }

    return HttpAxiosRequest.post(endpoint, operacion)

    // .then(response => {
    //     return Promise.resolve(response)
    // })
    // .catch(error => {
    //     console.error('Error de red:', error)

    //     return Promise.reject('Error de red.')
    // })
}
